module.exports = __webpack_public_path__ + "img/homekids.61b46fca.png";